import { getToken, setToken, removeToken } from '@/utils/auth'
import {
  loginPhonePassword,
  loginByWechat,
  getUserInfo as A_getUserInfo,
  updateStore,
} from '@/api/login'
import { getInfo } from '@/api/setting/index'
import { Notify } from 'vant'
import { delQIYU } from '@/utils/qiyukf'

const state = {
  customerId: null,
  forwardId: null, // 当前账号如果是小b 值为自己customerId；当前账号如果是小c 值为上级分销商customerId
  userInfoMobile: null, // 用户手机号
  userInfoAccount: null, // 用户账号
  userInfoAvatar: null, // 用户头像
  userInfoRank: null, // 分销员等级名称
  userInfoNickname: null, // 用户昵称
  distributionFlag: true, // false 客户 true 分销员
  scrollTop: 0, //检测homed点进去的列表页滚动距离
  wechat_login_status: null // 微信登录成功 有绑定则 true 否则 false
}

const mutations = {
  M_UPDATE_WECHAT_LOGIN_STATUS(state, status) {
    state.wechat_login_status = status;
  },
  SET_scrollTop(state, scrollTop) {
    state.scrollTop = scrollTop
  },

  SET_COUSTOMER_ID(state, id) {
    state.customerId = id
  },
  SET_USERINFO(state, data) {
    state.customerId = data.id
    state.userInfoAccount = data.account
    state.userInfoMobile = data.mobile
    state.distributionFlag = data.distributionFlag
    state.userInfoAvatar = data.imgUrl
    state.forwardId = data.distributionFlag ? data.id : data.storeId
    state.userInfoNickname = data.name
  },
  SET_USERINFO_RANK(state, data) {
    state.userInfoRank = data
  },
  RESET_COUSTOMER_ID(state) {
    state.customerId = null
  },
}

const actions = {
  loginPhonePassword({ commit }, data) {
    return new Promise((resolve, reject) => {
      loginPhonePassword(data)
        .then((res) => {
          if (res.error_description) {
            Notify({
              message: res.error_description,
              type: 'danger',
              duration: 3 * 1000,
            })
            reject()
            return
          }
          setToken(res.access_token)
          resolve()
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  loginByWechat({ commit }, data) {
    return new Promise((resolve, reject) => {
      loginByWechat(data)
        .then((res) => {
          console.log('loginByWechat：', res)
          if (res.error_description) {
            Notify({
              message: res.error_description,
              type: 'danger',
              duration: 3 * 1000,
            })
            commit("M_UPDATE_WECHAT_LOGIN_STATUS", false)
            reject()
            return
          }
          commit("M_UPDATE_WECHAT_LOGIN_STATUS", true)
          setToken(res.access_token)
          resolve()
          return
        })
        .catch((error) => {
          reject(error)
          return
        })
    })
  },
  setLoginInfo({ commit }, data) {
    setToken(data.access_token)
  },
  // 获取用户信息 （后端存在redis，数据无法更新，只用于获取customerId）
  getUserInfo({ commit }) {
    return new Promise((resolve, reject) => {
      const token = getToken()
      console.log(token)
      A_getUserInfo({ token }).then((res) => {

        localStorage.setItem("getuserinfoId", res.details.id)
        commit('SET_COUSTOMER_ID', res.details.id)
        resolve(res.details)
      }).catch((error) => {
        console.log("error getUserInfo action", error)
        localStorage.setItem("getuserinfo", error.stack)
        reject(error)
      })








    })
  },
  // 客户更换上级分销员
  updateStore({ commit }, storeId) {
    return new Promise((resolve, reject) => {
      updateStore({
        customerId: state.customerId,
        storeId: storeId,
      })
        .then((res) => {
          resolve()
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  // 获取用户信息（用这个-实时数据）
  getUserInfoDetail({ commit }, id) {
    return new Promise((resolve, reject) => {
      getInfo(id)
        .then((res) => {
          commit('SET_USERINFO', res.data)
          resolve()
        })
        .catch((error) => {
          console.log("getUserInfoDetail in actions")
          reject(error)
        })
    })
  },
  // 获取用户等级
  setUserInfoRank({ commit }, userInfoRank) {
    commit('SET_USERINFO_RANK', userInfoRank)
  },
  resetToken({ dispatch, commit }) {

    console.log("resetToken")
    return new Promise((resolve) => {
      removeToken()
      commit('RESET_COUSTOMER_ID')
      delQIYU()
      dispatch('app/getMessageNumStop', {}, { root: true })
      resolve()
    })
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
